module.exports = __webpack_public_path__ + "static/img/61-3.1581cb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/61-3.jpg
// module id = +ac9
// module chunks = 0